import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useProductOverlay } from "../productOverlay/productOverlayContext";
import { productLinkState } from "./productPageOverlayContext";

export const OVERLAY_BASE_Z_INDEX = 1022;

const isOverlayFamily = (to, location) => {
  const url = new URL(String(to), window.location.origin + location.pathname);
  const params = new URLSearchParams(location.search);
  params.delete("sku");
  const familySearch = params.toString() ? `?${params.toString()}` : "";
  return `${url.pathname}${url.search}`.toLowerCase() === `${location.pathname}${familySearch}`.toLowerCase();
};

export const useOpenProduct = (enabled) => {
  const navigate = useNavigate();
  const location = useLocation();
  const productOverlay = useProductOverlay();
  return useCallback(
    (to) => {
      if (productOverlay?.isOverlay && isOverlayFamily(to, location)) {
        productOverlay.closeProduct();
        return;
      }
      const from = { fromUrlPath: location.pathname, fromUrlSearch: location.search };
      if (enabled) window.history.scrollRestoration = "manual";
      navigate(to, { state: enabled ? { ...from, ...productLinkState(location) } : from });
    },
    [navigate, location, enabled, productOverlay],
  );
};
